import React from 'react';

import Footer from './Footer';

const Projects = () => {
    return (
        <>

            {/* Blue Theme Header */}
            <section style={{ background: 'linear-gradient(135deg, #1e40af 0%, #3b82f6 50%, #2563eb 100%)', color: 'white', padding: '2.5rem 0' }}>
                <div className="container">
                    <h1 style={{ fontSize: '2.25rem', fontWeight: '700', display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                        <i className="fas fa-project-diagram"></i>
                        My Projects
                    </h1>
                    <p style={{ fontSize: '1rem', opacity: 0.9 }}>A collection of your projects and contributions.</p>
                </div>
            </section>

            {/* Main Content */}
            <div className="main-content" style={{ width: '100%', margin: '2rem 0', paddingLeft: '40px', paddingRight: '40px', display: 'block' }}>
                <main className="job-listings" style={{width: '100%'}}>
                    <div style={{ textAlign: 'center', padding: '4rem 0', background: '#fff', borderRadius: '12px', border: '1px solid #e0e7ff' }}>
                        <i className="fas fa-hard-hat" style={{ fontSize: '4rem', color: '#d1d5db', marginBottom: '1rem' }}></i>
                        <h2 style={{ fontSize: '1.5rem', color: '#1f2937' }}>No Projects Yet</h2>
                        <p style={{ color: '#6b7280' }}>Your projects will appear here once you've added them.</p>
                    </div>
                </main>
            </div>

            <Footer />
        </>
    );
};

export default Projects;
